'use strict';

angular.module('accessModule', [
    'ngKomondor'
])

.config(function (usersStateOptionsProvider, kdAuthProvider)
{
    let user = kdAuthProvider.getInitialUser();

    if (user) {

        let perm = user.permissions || [];

        if (perm.indexOf('role-management') > -1) {
            usersStateOptionsProvider.config.edit.templateUrl = 'access/user.edit.html';
        }
    }
});


